export const StockImportTypeEnum = {
  Overwrite: 'overwrite',
  Add: 'add',
};
